const rv_dialog = {
    data: {
        show: false, // 是否显示
        type: 'alert', // 类型(tip/alert/confirm/loading/img)
        message: '', // 内容
        confirmText: '', // 确认文本
        cancelText: '', // 取消文本
        confirmCallBack: () => {}, // 确认回调
        cancelCallBack: () => {}, // 取消回调
        stopTip: false, // 阻止提示框(axios内嵌)
        stopLoading: false, // 阻止加载框(axios内嵌)
        width: '', // 图片宽度
        height: '', // 图片高度
        src: '' // 图片路径
    },
    /** 提示框 **/
    tip(message, confirmCallBack) {
        this.data.show = true
        this.data.type = 'tip'
        this.data.message = message
        setTimeout(() => {
            this.data.show = false
            if (confirmCallBack !== undefined) {
                confirmCallBack()
            }
        }, 2000)
    },
    /** 警告框 **/
    alert(message, confirmCallBack) {
        this.data.show = true
        this.data.type = 'alert'
        this.data.message = message
        if (confirmCallBack !== undefined) {
            this.data.confirmCallBack = confirmCallBack
        } else {
            this.data.confirmCallBack = undefined
        }
    },
    /** 确认框 **/
    confirm(message, cancelText, cancelCallBack, confirmText, confirmCallBack) {
        this.data.show = true
        this.data.type = 'confirm'
        this.data.message = message
        this.data.cancelText = cancelText
        if (cancelCallBack !== undefined) {
            this.data.cancelCallBack = cancelCallBack
        }
        this.data.confirmText = confirmText
        if (confirmCallBack !== undefined) {
            this.data.confirmCallBack = confirmCallBack
        }
    },
    /** 图片框 **/
    img(src, width, height) {
        this.data.show = true
        this.data.type = 'img'
        this.data.src = src
        this.data.width = width
        this.data.height = height

        this.stopMove();
    },

    /** 确认框 **/
    delete(message, cancelText, cancelCallBack, confirmText, confirmCallBack) {
        this.data.show = true
        this.data.type = 'delete'
        this.data.message = message
        this.data.cancelText = cancelText
        if (cancelCallBack !== undefined) {
            this.data.cancelCallBack = cancelCallBack
        }
        this.data.confirmText = confirmText
        if (confirmCallBack !== undefined) {
            this.data.confirmCallBack = confirmCallBack
        }
    },

    /**
     * 编辑地址
     * @param
     * @return
     */
    editorAddr(confirmCallBack) {
        this.data.show = true
        this.data.type = 'editorAddr'

        if (confirmCallBack !== undefined) {
            this.data.confirmCallBack = confirmCallBack
        }
    },

    /**
     * 新增地址
     * @param
     * @return
     */
    addAddr(confirmCallBack) {
        this.data.show = true
        this.data.type = 'addAddr'

        if (confirmCallBack !== undefined) {
            this.data.confirmCallBack = confirmCallBack
        }
    },

    /** 阻止提示 **/
    stopTip() {
        this.data.stopTip = true
    },
    /** 阻止加载 **/
    stopLoading() {
        this.data.stopLoading = true
    },

    // 停止页面滚动
    stopMove() {
        document.body.style.overflow = 'hidden';
        document.addEventListener('touchmove', this.preventDefault, { passive: false }); // 禁止页面滑动
    },

    preventDefault(e) {
        e.preventDefault();
    }
}

export {rv_dialog}



// WEBPACK FOOTER //
// ./src/utils/DialogUtils.js